import { NgModule } from '@angular/core'
import { UncheckOnDocumentClickDirective } from './uncheck-on-document-click.directive'

@NgModule({
  imports: [],
  declarations: [UncheckOnDocumentClickDirective],
  exports: [UncheckOnDocumentClickDirective]
})
export class UncheckOnDocumentClickModule {}
